import { MapPinIcon } from "@heroicons/react/24/outline";
export const DropsIcon = (props?: React.ComponentProps<"svg">) => (
  <MapPinIcon className="w-6 h-6" {...props} />
);
